import { Directive, EventEmitter, HostListener, Output } from "@angular/core";
import { ArbetsorderSearchBase } from "./arbetsorder-search-base";

@Directive()

export abstract class ArbetsorderSearchBasePanel extends ArbetsorderSearchBase {

    @Output() visibilityChanged: EventEmitter<ArbetsorderSearchBasePanel> = new EventEmitter<ArbetsorderSearchBasePanel>();

    isVisible = false;
    insideClick = false;

    constructor() {
        super();
    }

    abstract isDirty(): boolean;

    @HostListener("click", ["$event"]) clickinside(event: any) {
        this.insideClick = true;
    }

    @HostListener("document:click", ["$event"]) clickout(event: any) {
        if (!this.isVisible) {
            return;
        }
        if (!this.insideClick) {
            this.hide();
        }
        this.insideClick = false;
    }

    hide() {
        this.isVisible = false;
    }

    show() {
        this.isVisible = true;
    }

    toggleShow() {
        if (this.isVisible) {
            this.hide();
        } else {
            this.show();
            this.visibilityChanged.emit(this);
        }
    }
}
